<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-volume-up</v-icon>
        <span class="m-l-5">Static audio</span>
      </div>
      <div>
        <v-icon
          small
          class="m-r-5 m-l-20"
          :disabled="!prompt.path"
          @click="playPrompt"
        >
          {{ isPlaying ? 'fa-stop-circle' : 'fa-play-circle' }}
        </v-icon>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <v-autocomplete
      class="top-5 no-drag"
      v-model="prompt.path"
      :items="items"
      item-text="allText"
      item-value="path"
      dense
      hide-details
    >
      <!-- <template slot="selection" slot-scope="{ item }">
        <v-tooltip top :open-delay="700">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="float-right width100 font-size-sub m-r-5"
            >
              <div class="dropdown-title">
                {{ subString(item.text) }}
              </div>
              <div class="dropdown-text">
                {{ subString(item.path) }}
              </div>
            </div>
          </template>
          <span class="font-size-body">
            {{ item.text }}<br />{{ item.path }}
          </span>
        </v-tooltip>
      </template> -->
      <template slot="selection" slot-scope="{ item }">
        {{ subString(item.path, 70) }}
      </template>
      <template slot="item" slot-scope="{ item }">
        <v-tooltip top :open-delay="700">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="float-right width100 font-size-sub margin8px m-r-5"
            >
              <div class="dropdown-text">
                {{ subString(item.path, 70) }}
              </div>
              <div class="dropdown-title">
                {{ subString(item.text, 50) }}
              </div>
            </div>
          </template>
          <span class="font-size-body">
            {{ item.path }}<br />{{ item.text }}
          </span>
        </v-tooltip>
      </template>
    </v-autocomplete>
    <div v-if="description" class="box-description">
      {{ description }}
    </div>

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PayloadFile',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array,
    isMainPlaying: Boolean
  },
  data() {
    return {
      previewVoice: '',
      signedUrlSelect: '',
      isPlaying: false,
      description: ''
    }
  },
  watch: {
    prompt: {
      deep: true,
      handler(val) {
        if (this.prompt.path) {
          const find = _.find(this.items, { path: this.prompt.path })
          this.description = find ? find.text : ''
          this.signedUrlSelect = find ? find.sign_url : ''
        } else {
          this.description = ''
          this.signedUrlSelect = ''
        }
      }
    },
    items: {
      immediate: true,
      handler() {
        if (this.items && this.items.length > 0) {
          const find = _.find(this.items, { path: this.prompt.path })
          this.description = find ? find.text : ''
          this.signedUrlSelect = find ? find.sign_url : ''
        }
      }
    },
    isMainPlaying: {
      handler(val) {
        if (this.isMainPlaying) {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      }
    }
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlaying = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      this.isPlaying = false
    })

    this.items.forEach(e => (e.allText = `${e.text} ${e.path}`))
  },
  methods: {
    playPrompt() {
      try {
        if (!this.isPlaying) {
          if (this.prompt.path) {
            this.previewVoice = this.signedUrlSelect // `${this.minioHost}${this.prompt.path}`

            this.$refs.myAudio.load()

            setTimeout(() => {
              this.$refs.myAudio.play()
              this.isSubPlaying()
            }, 300)
          }
        } else {
          this.$refs.myAudio.pause()
          this.isPlaying = false
        }
      } catch {}
    },
    isSubPlaying() {
      this.$emit('isSubPlaying', null)
    },
    subString(text, length) {
      if (text.length < length) return text
      return `${text.substr(0, length)}...`
    },
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.font-size-body {
  max-width: 300px;
  display: flex;
  text-align: justify;
  text-justify: inter-word;
  padding-left: 4px;
  margin-left: 4px;
  padding-right: 4px;
  margin-right: 4px;
  margin-bottom: 0px;
  word-wrap: break-word;
}

.width20px {
  min-width: 20px;
}

.top-5 {
  margin-top: 5px;
  padding: 5px 10px 10px 10px;
  background: white;
}

.dropdown-title {
  font-size: 14px;
}

.dropdown-text {
  font-size: 11px;
  color: $text-color;
}

.margin8px {
  margin: 8px 0;
}

.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}

.box-description {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #cccccc;
}

.voice-header {
  display: flex;
  justify-content: space-between;
}
</style>
